<template>
  <div id="App">
    <router-view v-slot="{Component}">
      <Transition name="fade-transform" mode="out-in">
          <keep-alive :max="10">
             <component :is="Component"></component>	
          </keep-alive>
        </Transition>
      </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  mounted() {
    
  },
}
</script>
<style lang="less">
.van-field__control:disabled{
  color:#333!important;
  -webkit-text-fill-color:#333!important;
}
.van-field__body  input::-webkit-input-placeholder{
  color:#AAAAAA;
}
.van-field__body  input::-moz-input-placeholder{
  color:#AAAAAA;
}
.van-field__body  input::-ms-input-placeholder{
  color:#AAAAAA;
}
.van-field__body  input:-ms-input-placeholder{
  color:#AAAAAA;
}
.van-field__body input::placeholder{
  color:#AAAAAA!important;
}
.table-input{
		.van-cell{
			background: none;
			padding:5px 5px;
			.van-cell__value{
				font-size: 12px;
				color:#333;
			}
			.van-field__body  input::-webkit-input-placeholder{
				color:#333;
			}
			.van-field__body  input::-moz-input-placeholder{
			color:#333;
			}
			.van-field__body  input::-ms-input-placeholder{
			color:#333;
			}
			.van-field__body  input:-ms-input-placeholder{
			color:#333;
			}
			.van-field__body input::placeholder{
			color:#333!important;
			}
		}
	} 
.van-nav-bar .van-icon{
  color: #333!important;
}
.wobble-active {
  animation: waggle 3s infinite;
}
.van-nav-bar{
  z-index: 100;
  // background:black!important;
}

.tan-box{
		width: 80vw;
		min-height: 26vh;
		padding-top: 20px;
		// background: url("@/assets/imgs/default_bg_pop.png") no-repeat left top / 100% 100%;
		overflow: hidden;
	}

@keyframes waggle {
  0%,
  7% {
    transform: rotate(0);
  }
  15%, 65% {
    transform: rotate(-15deg);
  }
  20%, 70% {
    transform: rotate(10deg);
  }
  25%, 75% {
    transform: rotate(-10deg);
  }
  30%, 80% {
    transform: rotate(6deg);
  }
  35%, 85% {
    transform: rotate(-4deg);
  }
  40%, 57%, 90%,
  100% {
    transform: rotate(0);
  }
}


.border-fff{
  border:1px solid #fff;
  border-radius: 8px;
}

.van-cell:after{
border-color:#e6e6e6 !important;
}

.login-wrap{
  .van-cell{
    height: auto;
    padding: 0;
    padding-bottom: 0;
    .van-field__body{
      height:36px;
      line-height: 36px;
      input{
        height: 36px;
        line-height: 36px;
      }
    }
    .van-field__error-message{
      line-height: 20px;
      margin-top: 3px;
    }
    #password,#password1{
      font-size: 20px!important;
      font-weight: 700;
      letter-spacing: 3px;
      margin-bottom: 4px;
      // line-height: 36px;
    }
    #password::-webkit-input-placeholder,#password1::-webkit-input-placeholder{
      font-size: 14px!important;
      line-height: 36px;
      font-weight: 400;
      letter-spacing:0;
    }
    #password::-moz-input-placeholder,#password1::-moz-input-placeholder{
      font-size: 14px!important;
      line-height: 36px;
      font-weight: 400;
      letter-spacing:0;

    }
    #password::-ms-input-placeholder,#password1::-ms-input-placeholder{
      font-size: 14px!important;
      line-height: 36px;
      font-weight: 400;
      letter-spacing:0;

    }
    #password::placeholder,#password1::placeholder{
      font-size: 14px!important;
      line-height: 36px;
      font-weight: 400;
      letter-spacing:0;

    }
  }
  .bottom .van-cell{
    height: 55px;
  }
 .bottom .van-cell::before{
       content:"";
			width: 100%;
			top:36px;
			height: 1Px;
			background: #eee;
			position: absolute;
			left: 0;
  }
}
.home-wrap{
  .search-wrap{
    .van-cell{
      padding-left: 10px;
    }
  }
}

.van-nav-bar{
  background: #EEEEEE!important;
}
.wordItem{
  .item{
    background: linear-gradient( 90deg, #FFFFFF 37%, #F2FBFF 100%);
    box-shadow: 0px 4px 18px 0px rgba(0,49,128,0.1);
    .right-btn{
      background: #EBF5FF;
    }
  }
}
::-webkit-scrollbar {
display: none;
}
.wrapper .tan-box{
  // margin: 0 45px;
  width: 76vw;
  min-height: 30vh;
  overflow: auto;
}
.wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .tan-box{
		margin-bottom: 80px;
    padding-top:50px;
		.tab-top{
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			margin: auto;
			width: 80px;
			z-index: 2;
		}
		.tan-content{
			width: 100%;
			min-height: 25vh;
			position: relative;
			z-index: 1;
			background: #fff;
			// top: 30px;
			padding-top: 50px;
		}
	}
}
.bg{
  background:#ECF6FF url('@/assets/imgs/bg.png') no-repeat left top / 100% auto;
}
.fm-img{
  width: 68px;
  height: 94px;
}
.fm-right{
  height:94px;
  .tag1{
    // display: inline-block;
    background: #F5F6FA;
    padding: 3px 8px;
  }
}
.unit-tan-box{
  background: url('@/assets/imgs/pass/mask.png') no-repeat left top / 100% auto;
}
.van-popup--center.van-popup--round{
  border-radius:9px!important;
}
.footer{
  height: 75px;
		width: 100vw;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 5;
		background: #fff;
		box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.1);
}
.head-img{
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.blue-tag{
  background: linear-gradient( 180deg, #40D9CC 0%, #4286F5 100%);
}
.Count-box{
  .van-cell{
    padding: 8px 0px;
    label{
      font-size: 30px;
      line-height: 40px;
      color:#333;
      font-weight: 600;
    }
  }
  #Count{
    font-size: 30px;
    font-weight: 600;
    color:#333;
  }
}

.add-member{
	background: linear-gradient( 95deg, #F9E9C5 0%, #F9EFD7 53%, #F2D390 100%);
	.btn-yellow{
		background: #EECA7C;
		color:#735205;
		margin-left: 10px;
		border-radius: 7px;
		letter-spacing: 1px;
		font-weight: 400;
	}
}
.syellow-bg{
	background: linear-gradient( 95deg, #735205 0%, #936B10 53%, #735205 100%);
	.btn-yellow1{
		background: #E5C67F;
	}
}
.seltan-box{
  height: 100%;
  width: 100%;
  .seltan-box-con{
    height: calc(100% - 110px);
    overflow-y: auto;
  }
}
</style>